export default "__VITE_ASSET__DaNWlE28__"